import React from 'react';
import Portal from '@common/components/Portal';
import StyledAppWrapper from '@common/components/AppWrapper';
import { Modal, ModalWrapper } from './ContentModal.styles';

export const ContentModal = ({ children, ...props }) => (
  <Portal selector="#portal">
    <StyledAppWrapper>
      <ModalWrapper>
        <Modal {...props}>{children}</Modal>
      </ModalWrapper>
    </StyledAppWrapper>
  </Portal>
);
